export const REQUIRED_FIELD = 'Required field';
export const WRONG_EMAIL = 'Invalid email';
export const WRONG_COORDINATES = 'Invalid coordinates';
export const WRONG_PASSWORD = 'Password must contain from 8 to 50 characters';
export const PASSWORDS_NO_MATCH = "Your passwords don't match";

export const EMAIL_CONDITION =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/i;

export const COORDINATES_CONDITION =
  /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)\s[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/i;
export const emailValidation = {
  required: WRONG_EMAIL,
  validate: (value: string) => {
    if (!value.trim().match(EMAIL_CONDITION)) {
      return WRONG_EMAIL;
    }

    return true;
  },
};

export const coordinateValidation = {
  required: WRONG_COORDINATES,
  validate: (value: string) => {
    if (!value.match(COORDINATES_CONDITION)) {
      return WRONG_COORDINATES;
    }

    return true;
  },
};

export const commonValidation = {
  required: REQUIRED_FIELD,
};

export const createPasswordValidation = {
  required: REQUIRED_FIELD,
  validate: (value: string) => {
    if (value.length < 8 || value.length > 50) {
      return WRONG_PASSWORD;
    }

    return true;
  },
};

export const updatePasswordValidation = {
  validate: (value: string | undefined) => {
    if (!value) {
      return true;
    }

    return createPasswordValidation.validate(value);
  },
};

export const confirmPasswordValidation = {
  required: PASSWORDS_NO_MATCH,
  validate: (value: string, values: { password: string }) => {
    if (value !== values.password) {
      return PASSWORDS_NO_MATCH;
    }

    return true;
  },
};
